{
  "sections": "Sections",
  "group": {
    "monitoring": "Monitoring",
    "access": "Access",
    "administration": "Administration"
  },
  "overview": "Overview",
  "map": "Network map",
  "nodes": "Nodes and monitors",
  "events": "Events",
  "perf": "Map benchmark",
  "vnc": "VNC console",
  "ssh": "Terminal",
  "video": "Video wall",
  "archive": "Video archive",
  "sessions": "Active sessions",
  "sites": "Sites",
  "credentials": "Credentials",
  "agents": "Agents",
  "notifications": "Notifications",
  "users": "Users",
  "audit": "Audit log",
  "collapse": "Collapse",
  "collapseMenu": "Collapse the menu",
  "expandMenu": "Expand the menu",
  "closeMenu": "Close the menu",
  "plannedHint": "{{label}} — this section arrives in a later phase",
  "soon": "soon",
  "noRoles": "no roles",
  "you": "You",
  "roles": "Roles",
  "version": "v{{version}} · phase {{phase}}"
}
